import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@lockton-apps/material';
import { UiModule } from '../../ui.module';

export interface FaqQuestion {
  id: number;
  title: string;
  content: string;
}

export interface FaqSection {
  id: number;
  title: string;
  icon?: string;
  iconColor?: string;
  questions: FaqQuestion[];
}

@Component({
    selector: 'lui-faq-accordion',
    imports: [CommonModule, UiModule, MaterialModule],
    templateUrl: './faq-accordion.component.html',
    styleUrls: ['./faq-accordion.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqAccordionComponent {
  @Input() faqs!: FaqSection[];
}
